import { render } from "./ShipModal.vue?vue&type=template&id=0bc7d461"
import script from "./ShipModal.vue?vue&type=script&lang=js"
export * from "./ShipModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__